import React, { useEffect, useState } from "react";
import api from "../../api";
import { Clock, ExternalLink, Newspaper } from "lucide-react";

export default function ZeroHedgeNews() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await api.get("/news/zerohedge");

        const receivedNews = Array.isArray(response.data)
          ? response.data
          : [];

        console.log(
          "Nombre de headlines ZeroHedge reçues :",
          receivedNews.length,
        );

        setNews(receivedNews);
      } catch (error) {
        console.error(
          "Erreur de chargement des news ZeroHedge",
          error,
        );

        setNews([]);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();

    const interval = setInterval(
      fetchNews,
      5 * 60 * 1000,
    );

    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return (
      <div className="flex h-full min-h-0 flex-col">
        <div className="mb-3 flex shrink-0 items-center gap-2 border-b border-workspace pb-2">
          <Newspaper className="h-5 w-5 text-secondary" />

          <h3 className="font-semibold text-primary">
            ZeroHedge Headlines
          </h3>
        </div>

        <div className="grid min-h-0 flex-1 grid-rows-4 gap-2 overflow-hidden">
          {Array.from({ length: 4 }).map((_, index) => (
            <div
              key={index}
              className="flex min-h-0 animate-pulse flex-col justify-between overflow-hidden rounded-lg border border-workspace bg-surface p-2"
            >
              <div>
                <div className="mb-2 h-4 w-full rounded bg-tertiary" />
                <div className="h-4 w-2/3 rounded bg-tertiary" />
              </div>

              <div className="mt-2 flex items-center gap-2">
                <div className="h-5 w-24 rounded-full bg-tertiary" />
                <div className="h-5 w-20 rounded-full bg-tertiary" />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="mb-3 flex w-full shrink-0 items-center justify-between border-b border-workspace pb-2">
        <div className="flex min-w-0 items-center gap-2">
          <Newspaper className="h-5 w-5 shrink-0 text-secondary" />

          <h3 className="truncate font-semibold text-primary">
            ZeroHedge Headlines
          </h3>
        </div>

        <img
          src="/assets/dashboard/zerohedge-logo.jpg"
          alt="ZeroHedge"
          className="ml-4 h-7 w-auto max-w-[120px] shrink-0 object-contain"
        />
      </div>

      {news.length === 0 ? (
        <div className="flex min-h-0 flex-1 items-center justify-center">
          <p className="text-center text-sm italic text-subtle">
            Aucune actualité disponible pour le moment.
          </p>
        </div>
      ) : (
        <div className="grid min-h-0 flex-1 grid-rows-4 gap-2 overflow-hidden">
          {news.slice(0, 4).map((item, index) => (
            <article
              key={item.link || `${item.title}-${index}`}
              className="group flex min-h-0 flex-col justify-between overflow-hidden rounded-lg border border-transparent bg-surface p-2 transition-all duration-200 hover:border-tertiary hover:bg-workspace hover:shadow-hp-sm"
            >
              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="flex min-h-0 items-start justify-between gap-3 rounded outline-none focus-visible:ring-2 focus-visible:ring-primary"
              >
                <h4 className="line-clamp-2 flex-1 text-sm font-semibold leading-snug text-primary transition-colors group-hover:text-secondary">
                  {item.title}
                </h4>

                <ExternalLink className="mt-0.5 h-4 w-4 shrink-0 text-subtle opacity-0 transition-opacity group-hover:text-secondary group-hover:opacity-100" />
              </a>

              <div className="mt-2 flex flex-wrap items-center gap-2 text-[11px] font-medium">
                <div className="flex items-center gap-1.5 rounded-full border border-workspace bg-surface-muted px-2 py-0.5 text-muted">
                  <Clock className="h-3 w-3 shrink-0" />

                  <span className="whitespace-nowrap">
                    {item.pubDate
                      ? `${new Date(
                          item.pubDate,
                        ).toLocaleTimeString("fr-FR", {
                          hour: "2-digit",
                          minute: "2-digit",
                        })} - ${new Date(
                          item.pubDate,
                        ).toLocaleDateString("fr-FR")}`
                      : "Date indisponible"}
                  </span>
                </div>

                <div className="min-w-0 rounded-full border border-transparent bg-primary-light px-2 py-0.5 text-primary">
                  <span className="inline-block max-w-[120px] truncate align-bottom">
                    {item.author || "ZeroHedge"}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}